@if (open) {
    <aside class="dlt-drawer" [class.dlt-drawer--resizing]="resizing" [style.width.px]="width">
        <div class="dlt-drawer-resize" (mousedown)="startResize($event)" title="Drag to resize"></div>
        <div class="dlt-drawer-header">
            <div class="dlt-drawer-heading">
                <span class="dlt-drawer-eyebrow">{{ eyebrow }}</span>
                @if (detailLink) {
                <a class="dlt-drawer-title dlt-drawer-title--link" [routerLink]="detailLink" (click)="close()">
                    <span
                        class="dlt-drawer-title__name"
                        #nameEl
                        (mouseenter)="nameTruncated = nameEl.scrollWidth > nameEl.clientWidth"
                        [matTooltip]="displayName"
                        [matTooltipDisabled]="!nameTruncated"
                        matTooltipPosition="below"
                        >{{ displayName }}</span
                    >
                    <svg
                        class="dlt-drawer-title__open"
                        viewBox="0 0 24 24"
                        width="14"
                        height="14"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2.25"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        [matTooltip]="'Open ' + entityNoun + ' details'"
                        matTooltipPosition="below"
                        aria-hidden="true"
                    >
                        <path d="M7 17L17 7M10 7h7v7" />
                    </svg>
                </a>
                } @else {
                <span
                    class="dlt-drawer-title"
                    #plainEl
                    (mouseenter)="nameTruncated = plainEl.scrollWidth > plainEl.clientWidth"
                    [matTooltip]="displayName"
                    [matTooltipDisabled]="!nameTruncated"
                    matTooltipPosition="below"
                    >{{ displayName }}</span
                >
                }
            </div>
            <div class="dlt-drawer-actions">
                @if (nav.total > 1) {
                    <!-- Page up/down through the filtered list the drawer was opened from. -->
                    <div class="dlt-drawer-pager">
                        <button
                            type="button"
                            class="dlt-pager-btn"
                            [disabled]="!nav.hasPrev"
                            [matTooltip]="'Previous ' + entityNoun"
                            matTooltipPosition="below"
                            (click)="navigate(-1)"
                            aria-label="Previous"
                        >
                            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"></polyline></svg>
                        </button>
                        <span class="dlt-pager-count">{{ nav.index + 1 }}<span class="dlt-pager-sep">/</span><span class="dlt-pager-total">{{ nav.total }}</span></span>
                        <button
                            type="button"
                            class="dlt-pager-btn"
                            [disabled]="!nav.hasNext"
                            [matTooltip]="'Next ' + entityNoun"
                            matTooltipPosition="below"
                            (click)="navigate(1)"
                            aria-label="Next"
                        >
                            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"></polyline></svg>
                        </button>
                    </div>
                }
                <button type="button" class="dlt-drawer-close" (click)="close()" aria-label="Close">&times;</button>
            </div>
        </div>
        <div class="dlt-drawer-body">
            <app-dial-logs-timeline-tab [data]="tabData"></app-dial-logs-timeline-tab>
        </div>
    </aside>
}
